// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuButton_wrapper__Lw0xt","dropdown":"MenuButton_dropdown__-tDiq","menuItem":"MenuButton_menuItem__O9dbw","disabled":"MenuButton_disabled__Z5fdg"};